import React from "react";

export default {
  hero: {
    width: "100%",
    backgroundColor: "transparent",
  } as React.CSSProperties,
  heroImage: {
    width: "100%",
    display: "block",
    objectFit: "cover",
  } as React.CSSProperties,
};
